import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noHtmlTagValidator(): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    if (!control.value) {
      return;
    }
    // Test regex on object 'name' of value if exists, or on the string value
    return /<\w[^>]*>/.test(control.value?.name || control.value)
      ? { containsHtmlTag: true }
      : null;
  };
}
